module.exports = __webpack_public_path__ + "img/img5.e8baa3fb.png";